// src/components/ProtectedRoute.js

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { AuthContext } from '../contexts/AuthContext';

function ProtectedRoute({ children, allowedRoles }) {
  const { currentUser, userRole, loading } = useContext(AuthContext);

  if (loading) {
    // Display a loading spinner while checking auth status
    return (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader size={50} color="#123abc" loading={loading} />
      </div>
    );
  }

  if (!currentUser) {
    // Redirect unauthorized users to the login page
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // User does not have the required role
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export default ProtectedRoute;
